import { useTranslation } from '../../hooks/useTranslation';
import styles from './AgreementButton.module.css';

interface AgreementButtonProps {
  onClick: () => void;
}

export const AgreementButton = ({ onClick }: AgreementButtonProps) => {
  const { t, selectedLocale } = useTranslation();

  return (
    <div className={styles.agreement_button_container}>
      <button
        onClick={onClick}
        className={styles.agreement_button}
      >
        {t('viewAgreement', selectedLocale)}
      </button>
    </div>
  );
};
